import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IDashboardState, IUsers } from './types';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
const initialState: IDashboardState = {
  dashboard: {},
  departedUsers: {},
  getFilteredInterns: {},
  getFilteredCandidates: {},
  getTasksOverview: {},
  getTasksOverviewById: {},
  getMyProjectLeaders: {},
  getProjectContribution: {},
  getTaskAssignment: {},
  getRemainingTasks: {},
};
const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    getDashboardData(state) {
      state.dashboard.status = RequestStatus.RUNNING;
    },
    getDashboardDataSuccess(state, action: PayloadAction<IDashboardState['dashboard']['data']>) {
      state.dashboard.status = RequestStatus.SUCCESS;
      state.dashboard.data = action.payload;
    },
    getDashboardDataFailed(state, action: PayloadAction<IRequestFailed>) {
      state.dashboard.status = RequestStatus.ERROR;
      state.dashboard.error = action.payload;
    },
    //
    getDepartedUsers(state, action: PayloadAction<string>) {
      state.departedUsers.status = RequestStatus.RUNNING;
    },
    getDepartedUsersSuccess(state, action: PayloadAction<IDashboardState['dashboard']['data']>) {
      state.departedUsers.status = RequestStatus.SUCCESS;
      state.departedUsers.data = action.payload;
    },
    getDepartedUsersFailed(state, action: PayloadAction<IRequestFailed>) {
      state.departedUsers.status = RequestStatus.ERROR;
      state.departedUsers.error = action.payload;
    },
    //
    getFilteredInterns(state, action: PayloadAction<IUsers>) {
      state.getFilteredInterns.status = RequestStatus.RUNNING;
    },
    getFilteredInternsSuccess(state, action: PayloadAction<IDashboardState['dashboard']['data']>) {
      state.getFilteredInterns.status = RequestStatus.SUCCESS;
      state.getFilteredInterns.data = action.payload;
    },
    getFilteredInternsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getFilteredInterns.status = RequestStatus.ERROR;
      state.getFilteredInterns.error = action.payload;
    },
    //
    getFilteredCandidates(state, action: PayloadAction<IUsers>) {
      state.getFilteredCandidates.status = RequestStatus.RUNNING;
    },
    getFilteredCandidatesSuccess(
      state,
      action: PayloadAction<IDashboardState['dashboard']['data']>
    ) {
      state.getFilteredCandidates.status = RequestStatus.SUCCESS;
      state.getFilteredCandidates.data = action.payload;
    },
    getFilteredCandidatesFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getFilteredCandidates.status = RequestStatus.ERROR;
      state.getFilteredCandidates.error = action.payload;
    },
    //
    getTasksOverview(state, action: PayloadAction<any>) {
      state.getTasksOverview.status = RequestStatus.RUNNING;
    },
    getTasksOverviewSuccess(state, action: PayloadAction<IDashboardState['dashboard']['data']>) {
      state.getTasksOverview.status = RequestStatus.SUCCESS;
      state.getTasksOverview.data = action.payload;
    },
    getTasksOverviewFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getTasksOverview.status = RequestStatus.ERROR;
      state.getTasksOverview.error = action.payload;
    },
    //
    getTasksOverviewById(state, action: PayloadAction<any>) {
      state.getTasksOverviewById.status = RequestStatus.RUNNING;
    },
    getTasksOverviewByIdSuccess(
      state,
      action: PayloadAction<IDashboardState['dashboard']['data']>
    ) {
      state.getTasksOverviewById.status = RequestStatus.SUCCESS;
      state.getTasksOverviewById.data = action.payload;
    },
    getTasksOverviewByIdFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getTasksOverviewById.status = RequestStatus.ERROR;
      state.getTasksOverviewById.error = action.payload;
    },
    //
    getMyProjectLeaders(state, action: PayloadAction<any>) {
      state.getMyProjectLeaders.status = RequestStatus.RUNNING;
    },
    getMyProjectLeadersSuccess(state, action: PayloadAction<IDashboardState['dashboard']['data']>) {
      state.getMyProjectLeaders.status = RequestStatus.SUCCESS;
      state.getMyProjectLeaders.data = action.payload;
    },
    getMyProjectLeadersFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getMyProjectLeaders.status = RequestStatus.ERROR;
      state.getMyProjectLeaders.error = action.payload;
    },
    //
    getProjectContribution(state, action: PayloadAction<any>) {
      state.getProjectContribution.status = RequestStatus.RUNNING;
    },
    getProjectContributionSuccess(
      state,
      action: PayloadAction<IDashboardState['dashboard']['data']>
    ) {
      state.getProjectContribution.status = RequestStatus.SUCCESS;
      state.getProjectContribution.data = action.payload;
    },
    getProjectContributionFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getProjectContribution.status = RequestStatus.ERROR;
      state.getProjectContribution.error = action.payload;
    },
    //
    getTaskAssignment(state) {
      state.getTaskAssignment.status = RequestStatus.RUNNING;
    },
    getTaskAssignmentSuccess(state, action: PayloadAction<IDashboardState['dashboard']['data']>) {
      state.getTaskAssignment.status = RequestStatus.SUCCESS;
      state.getTaskAssignment.data = action.payload;
    },
    getTaskAssignmentFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getTaskAssignment.status = RequestStatus.ERROR;
      state.getTaskAssignment.error = action.payload;
    },
    //
    getRemainingTasks(state, action: PayloadAction<{ userId?: number }>) {
      state.getRemainingTasks.status = RequestStatus.RUNNING;
    },
    getRemainingTasksSuccess(
      state,
      action: PayloadAction<IDashboardState['getRemainingTasks']['data']>
    ) {
      state.getRemainingTasks.status = RequestStatus.SUCCESS;
      state.getRemainingTasks.data = action.payload;
    },
    getRemainingTasksFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getRemainingTasks.status = RequestStatus.ERROR;
      state.getRemainingTasks.error = action.payload;
    },
  },
});
export default slice.reducer;
export const {
  getDashboardData,
  getDashboardDataFailed,
  getDashboardDataSuccess,
  getDepartedUsers,
  getDepartedUsersFailed,
  getDepartedUsersSuccess,
  getFilteredInterns,
  getFilteredInternsFailed,
  getFilteredInternsSuccess,
  getFilteredCandidates,
  getFilteredCandidatesFailed,
  getFilteredCandidatesSuccess,
  getTasksOverview,
  getTasksOverviewFailed,
  getTasksOverviewSuccess,
  getTasksOverviewById,
  getTasksOverviewByIdFailed,
  getTasksOverviewByIdSuccess,
  getMyProjectLeaders,
  getMyProjectLeadersFailed,
  getMyProjectLeadersSuccess,
  getProjectContribution,
  getProjectContributionFailed,
  getProjectContributionSuccess,
  getTaskAssignment,
  getTaskAssignmentFailed,
  getTaskAssignmentSuccess,
  getRemainingTasks,
  getRemainingTasksSuccess,
  getRemainingTasksFailed,
} = slice.actions;
